import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class DashboardAnalyticsModel extends BaseModel {
  static urlPath = "analytics";

  @attr("number") id;
  @attr("string") name;
  @attr("string") description;
  @attr("array") chartsSection;
  @attr("array") reportsSection;
}
